import { useIsRestoring, useQuery } from "@tanstack/react-query";
import { useAccessToken } from "@/hooks";
import {
  MAKEUP_SESSIONS_PAGE_SIZE,
  searchMakeupSessions,
  type MakeupSearchFilters,
} from "@/lib/services/makeupService";
import { getMakeupSessionsQueryKey } from "./makeup-sessions-query-key";

export { MEMBER_MAKEUP_SESSIONS_STALE_TIME_MS } from "./makeup-sessions-query-key";

export function useMakeupSessionsSearch({
  page = 1,
  pageSize = MAKEUP_SESSIONS_PAGE_SIZE,
  lastSelectedId,
  active,
  filters = {},
  enabled = true,
  staleTime,
  refetchOnMount,
  refetchInterval,
}: {
  page?: number;
  pageSize?: number;
  lastSelectedId?: string;
  active?: boolean;
  filters?: MakeupSearchFilters;
  enabled?: boolean;
  staleTime?: number;
  refetchOnMount?: boolean;
  refetchInterval?: number | false;
}) {
  const accessToken = useAccessToken();
  const isRestoring = useIsRestoring();

  return useQuery({
    queryKey: getMakeupSessionsQueryKey({
      page,
      pageSize,
      lastSelectedId,
      active,
      filters,
    }),
    enabled: enabled && !!accessToken && !isRestoring,
    refetchOnWindowFocus: false,
    staleTime,
    refetchOnMount,
    refetchInterval,
    queryFn: async () => {
      if (!accessToken) {
        throw new Error("Authentication token is required");
      }
      return searchMakeupSessions(accessToken, {
        page,
        pageSize,
        lastSelectedId,
        active,
        filters,
      });
    },
  });
}
